export default __webpack_public_path__ + "0c7cf3ac9354d6ff6dbf15c79cc762a8.svg";